import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, desc, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center" : ""}>
    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand" data-testid={`overline-${overline.toLowerCase().replace(/\s+/g, "-")}`}>
      {overline}
    </p>
    <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
      {title}
    </h2>
    {desc && (
      <p className={`mt-5 max-w-2xl text-base leading-relaxed text-slate-500 ${align === "center" ? "mx-auto" : ""}`}>
        {desc}
      </p>
    )}
  </Reveal>
);
